import constant from '@/common/resources/constant'

export default {
  methods: {
    getResultMessage (contentType) {
      const res = {
        messageAdd: '',
        messageDelete: ''
      }
      switch (contentType) {
        case 'program' :
          res.messageAdd = constant.MSG_COMPLETE_ADD_ZZIM_PROGRAM
          res.messageDelete = constant.MSG_COMPLETE_DELETE_ZZIM_PROGRAM
          break
        case 'live':
          res.messageAdd = constant.MSG_COMPLETE_ADD_ZZIM_LIVE
          res.messageDelete = constant.MSG_COMPLETE_DELETE_ZZIM_LIVE
          break
        case 'movie':
          res.messageAdd = constant.MSG_COMPLETE_ADD_ZZIM_MOVIE
          res.messageDelete = constant.MSG_COMPLETE_DELETE_ZZIM_MOVIE
          break
        case 'theme':
          res.messageAdd = constant.MSG_COMPLETE_ADD_ZZIM_THEME
          res.messageDelete = constant.MSG_COMPLETE_DELETE_ZZIM_THEME
          break
      }
      return res
    }
  },
  computed: {
    getIconStyle () {
      // switch (this.contentsType) {
      //   case 'movie':
      //     return this.isMypooq ? 'my-like' : 'movie'
      //   case 'program':
      //     return this.isMypooq ? 'my-subscribe' : 'subscribe'
      //   case 'theme':
      //     return this.isMypooq ? 'my-like' : 'editorpick'
      //   default:
      //     return this.isMypooq ? 'my-like' : 'like'
      // }
      return 'movie'
    },
    title () {
      return '관심'
    }
    //   if (this.contentsType === 'live') {
    //     return '좋아요'
    //   } else if (this.contentsType === 'theme' || this.contentsType === 'movie') {
    //     return this.value ? '찜하기' : '찜하기'
    //   } else {
    //     const subscriptText = '구독'
    //     if (this.value) {
    //       return subscriptText + '중'
    //     } else {
    //       return subscriptText
    //     }
    //   }
    // }
  }
}
